import React, {useEffect} from 'react';
import {useI18nContext} from "../../contexts/I18nContext";
import {useStyles} from "./MoneyServiceFees.style";
import Box from "../../ui_components/Box/Box";
import Width from "../../ui_components/common/enums/Width";
import Alignment from "../../ui_components/common/enums/Alignment";
import FilterInput from "../../shared_components/Inputs/FilterInput/FilterInput";
import Button from "../../ui_components/Button/Button";
import {Observer} from "mobx-react-lite";
import ShowPagination from "../../ui_components/ShowPagination/ShowPagination";
import MessageCard from "../../ui_components/MessageCard/MessageCard";
import CurrencyExchangeIcon from '@mui/icons-material/CurrencyExchange';
import {useCommonContext} from "../../contexts/CommonContext";
import ButtonType from "../../ui_components/Button/ButtonType";
import MoneyServiceFeeStore from './MoneyServiceFeeStore';
import MoneyServiceFeeRow from './MoneyServiceFeesRow/MoneyServiceFeeRow';
import NewMoneyDeliveryFeeButton from '../../shared_components/Buttons/NewMoneyDeliveryFeeButton/NewMoneyDeliveryFeeButton';
import ShowMoneyDeliveryCostsButton from '../../shared_components/Buttons/ShowMoneyDeliveryCostsButton/ShowMoneyDeliveryCostsButton';


const MoneyServiceFees: React.FC = () => {
    const commonStore = useCommonContext();
    const i18n = useI18nContext();
    const moneyServiceFeeStore = new MoneyServiceFeeStore(commonStore);
    const classes = useStyles();

    useEffect(() => {
        moneyServiceFeeStore.getElements();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const onUpdate = async () => {
        await moneyServiceFeeStore.getElements();
    }

    const onPaginationChange = async (page: number, pageSize: number) => {
        await moneyServiceFeeStore.goToPage(page, pageSize);
    }


    return (
        <Observer>
            {() => (
                <div className={classes.foodPackages_container}>
                    <Box className={classes.tools_container}
                         width={Width.FULL_WIDTH}
                         justifyContent={Alignment.END}
                    >
                        <ShowMoneyDeliveryCostsButton type={ButtonType.SECONDARY}/>
                        <NewMoneyDeliveryFeeButton type={ButtonType.SECONDARY} onSave={onUpdate}/>
                    </Box>
                    <Box className={classes.filter_container} width={Width.FULL_WIDTH}
                         justifyContent={Alignment.SPACE_BETWEEN}>
                        <FilterInput value={moneyServiceFeeStore.filter}
                                     placeholder={i18n.translate("MONEY_SERVICE_FEES_FILTER_PLACEHOLDER")}
                                     onChange={(value) => {
                                        moneyServiceFeeStore.setFilter(value)
                                     }} onEnter={() => moneyServiceFeeStore.search()}/>
                        <Button
                            onClick={() => {
                                moneyServiceFeeStore.search()
                            }}
                            className={classes.search_btn}
                            text={i18n.translate("SEARCH")}
                        />
                    </Box>
                    {!moneyServiceFeeStore.isEmpty &&
                    <div className={classes.foodPackages_table}>
                        <ShowPagination onChange={onPaginationChange}
                                        elementLabel={i18n.translate("MONEY_SERVICE_FEES")}
                                        pagination={moneyServiceFeeStore.pagination}/>
                        <div className={classes.elements_container}>
                            {moneyServiceFeeStore.moneyServiceFees.map((moneyServiceFee, i) => (
                                <MoneyServiceFeeRow
                                    onUpdate={onUpdate}
                                    moneyServiceFee={moneyServiceFee} key={i}
                                />
                            ))}
                        </div>
                        <ShowPagination
                            onChange={onPaginationChange}
                            elementLabel={i18n.translate("MONEY_SERVICE_FEES")}
                            pagination={moneyServiceFeeStore.pagination}/>
                    </div>}
                    {moneyServiceFeeStore.isEmpty &&
                    <MessageCard icon={CurrencyExchangeIcon} title={i18n.translate("NO_MONEY_SERVICE_FEE_TITLE")}
                                 subtitle={i18n.translate("NO_MONEY_SERVICE_FEE_SUBTITLE")}/>}
                </div>
            )}
        </Observer>
    )
}

export default MoneyServiceFees;
